import CustomFieldHOC from '@common/components/CustomFieldHOC';
import { ProductAddToCartHOCRenderArgs } from '@common/components/ProductAddToCartHOC';
import ProductOptionsHOC from '@common/components/ProductOptionsHOC';
import useOnScreen from '@common/hooks/useOnScreen';
import Product, { PRODUCT_TYPE } from '@common/models/Product';
import { STORE_TYPE } from '@common/models/StoreInfo';
import { subtractProductFromCart } from '@common/store/cart/slice';
import { addToast, ToastWithKeyType } from '@common/store/toasts/slice';
// import { addToast, removeToast, ToastWithKeyType } from '@common/store/toasts/slice';
import history from '@common/utils/history';
import Rupee from '@components/Rupee';
import SelectVariants from '@components/SelectVariants';
import WishlistIcon from '@components/WishlistIcon';
import minus from '@images/minus.svg';
import plus from '@images/plus.svg';
import classnames from 'classnames';
import React, { useRef, useState } from 'react';

import FormCheckboxRadioGroup from '../../../../lib-components/FormCheckboxRadioGroup';
import FormInput from '../../../../lib-components/FormInput';

interface ProductAddToCart {
  product: Product;
  cartProductQuantity: number;
  addToast: typeof addToast;
  hocArgs: ProductAddToCartHOCRenderArgs;
  subtractProductFromCart: typeof subtractProductFromCart;
  storeType: string;
  quickView?: boolean;
  isEvent?: boolean;
  review?: number;
  scrollToReview?: () => void;
  toasts?: ToastWithKeyType[];
  wishListFeature: boolean;
  taxIncludedInventory: boolean;
}

const ProductAddToCart: React.FC<ProductAddToCart> = ({
  product,
  quickView,
  hocArgs,
  storeType,
  // isEvent,
  wishListFeature,
  taxIncludedInventory,
  // toasts,
}) => {
  const {
    finalProduct,
    editedPrice,
    eventStartDate,
    eventStartTime,
    eventEndDate,
    eventEndTime,
    setEditedPrice,
    editedPriceError,
    addToCart,
    variant,
    isBuyNowButtonDisabled,
    isAddToCartButtonDisabled,
    showAddToCartButtonAlt,
    discountCode,
    finalPrice,
    savings,
    showTicketsLeft,
    onWishListClickHandler,
    wishlist,
  } = hocArgs;
  const { selectedOptions, setSelectedOptions, quantity, setQuantity, selectedVariantCartQuantity } = variant;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [error, seterror] = useState(false);
  const [showError, setshowError] = useState(false);
  const cartCtaRef = useRef<HTMLDivElement>(null);
  const ctaRef = useRef<HTMLDivElement>(null);
  const showFixedBuyNow = !useOnScreen(cartCtaRef) && !quickView && !isBuyNowButtonDisabled;
  const { isProductInWishList } = wishlist;
  const validate = (selectedArray): number => {
    const filteredArray = selectedArray.filter((val) => {
      return val !== -1;
    });
    if (filteredArray.length === selectedArray.length) {
      return 1;
    } else {
      return 0;
    }
  };
  const BuyNowValidate = () => {
    if (product.type !== PRODUCT_TYPE.DIGITAL) {
      if (quantity !== -1 && validate(selectedOptions)) {
        addToCart({ isBuyNowFlow: true, discountLinkPromoCode: discountCode });
      } else {
        setshowError(true);
        setTimeout(() => {
          setshowError(false);
        }, 2000);
      }
    } else {
      addToCart({ isBuyNowFlow: true, discountLinkPromoCode: discountCode });
    }
  };
  return (
    <div className={'flex flex-col flex-1'}>
      <div className="hidden md:flex">{CostBar(finalPrice, savings, taxIncludedInventory)}</div>

      {finalProduct.type === PRODUCT_TYPE.EVENT ? (
        <div className="flex flex-col mt-50 md:mt-50 w-full md:w-340" font-customisation="para-text">
          <div className="grid grid-cols-2 ">
            <div
              className="text-input-search md:text-textScolor font-normal text-16 leading-24 "
              color-customisation="page-body-text"
            >
              Date
            </div>
            <div className="text-input-search text-16 leading-24 font-normal " color-customisation="page-body-text">
              {eventStartDate === eventEndDate ? (
                <>
                  <div>{eventStartDate},</div>
                </>
              ) : (
                <>
                  {eventStartDate}&nbsp; - &nbsp;{eventEndDate}
                </>
              )}
            </div>
          </div>
          <div className="grid grid-cols-2  mt-30">
            <div
              className="text-input-search md:text-textScolor font-normal text-16 leading-24 "
              color-customisation="page-body-text"
            >
              Time
            </div>
            <div className="text-input-search text-16 leading-24 font-normal" color-customisation="page-body-text">
              {eventStartTime === eventEndTime ? (
                <>
                  {eventStartTime}&nbsp; {'Onwards'}
                </>
              ) : (
                <>
                  <div>
                    {eventStartTime}&nbsp; - &nbsp;{eventEndTime}
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="grid grid-cols-2  mt-30 cursor-pointer">
            <div
              className="text-input-search md:text-textScolor font-normal text-16 leading-24 "
              color-customisation="page-body-text"
            >
              Venue
            </div>
            <div
              className="flex flex-wrap text-input-search text-16 leading-24 font-normal"
              color-customisation="page-body-text"
            >
              {finalProduct.event?.venue}
            </div>
          </div>
          {showTicketsLeft ? (
            <div className="grid grid-cols-2 mt-30">
              <div
                className="text-input-search md:text-textScolor font-normal text-16 leading-24 "
                color-customisation="page-body-text"
              >
                Tickets Available
              </div>
              <div
                className="flex flex-wrap text-input-search text-16 leading-24 font-normal"
                color-customisation="page-body-text"
              >
                {finalProduct?.stock}
              </div>
            </div>
          ) : null}
          <div className="grid grid-cols-2 mt-30">
            <div
              className={classnames(
                ' text-textGray md:text-textScolor font-normal text-16 leading-24 flex items-center',
                {},
              )}
              color-customisation="page-body-text"
            >
              Quantity
            </div>
            <div className="flex flex-row items-center">
              <div
                className={classnames(
                  'flex justify-between items-center rounded-22 text-textScolor text-16 leading-22 font-normal cursor-pointer',
                  {
                    'w-165 min-w-165 md:h-36 h-44': !quickView,
                    'md:w-110 w-164 h-36': quickView,
                  },
                )}
              >
                <button
                  className="hover:focus:outline-none ripple focus:shadow-none flex justify-center items-center w-36 h-36 rounded-5 bg-esteem-review border border-esteem-btnBorder1"
                  onClick={() => setQuantity(Math.max(quantity - 1, 1))}
                  disabled={selectedVariantCartQuantity ? quantity === 1 : product.minQuantity === quantity}
                >
                  <img src={minus} alt="-" className="" />
                </button>
                <div
                  className="flex focus:outline-none justify-center items-center"
                  color-customisation="page-body-text"
                >
                  {quantity}
                </div>
                <button
                  className="focus:outline-none ripple focus:shadow-none flex justify-center items-center w-36 h-36 rounded-5 bg-esteem-review border border-esteem-btnBorder1"
                  onClick={() => setQuantity(quantity + 1)}
                  disabled={
                    product.stock >= product.maxQuantity ? product.maxQuantity === quantity : product.stock === quantity
                  }
                >
                  <img src={plus} alt="+" className="" />
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {product.type !== PRODUCT_TYPE.DIGITAL ? (
        <div className="">
          <>
            {product.type !== PRODUCT_TYPE.EVENT ? (
              <div className="xl:w-509 w-full mt-48 md:mt-40 flex flex-wrap items-center">
                {QuantityOptionsBar(quantity, setQuantity, finalProduct, selectedVariantCartQuantity, quickView)}
              </div>
            ) : null}
            {finalProduct.minQuantity > 1 ? (
              <div className="flex items-center w-full mt-30 " font-customisation="para-text">
                <div
                  className="text-16 flex font-normal text-textGray md:text-textScolor min-w-120"
                  color-customisation="page-body-text"
                >
                  Min Order Qty
                </div>
                <div className="text-textScolor text-16 leading-22 font-normal" color-customisation="page-body-text">
                  {finalProduct.minQuantity}
                </div>
              </div>
            ) : null}
          </>
        </div>
      ) : null}
      {product.hasVariants ? (
        // <div className="mt-25 flex justify-center md:justify-start flex-col mx-34 md:mx-0">
        <div className="mt-25 flex justify-center md:justify-start flex-col" font-customisation="para-text">
          <SelectVariants
            product={product}
            selectedOptions={selectedOptions}
            setSelectedOptions={setSelectedOptions}
            quantity={quantity}
            setQuantity={setQuantity}
            quickView={quickView}
          />
        </div>
      ) : null}
      {finalProduct.payWhatYouWant ? (
        <FormInput
          name={'price'}
          className="mt-16 text-16 font-bold text-title"
          label={`Pay what you want (Min ₹${finalProduct.finalPrice})`}
          type="text"
          value={editedPrice}
          onChange={(e) => setEditedPrice(e.target.value)}
          onBlur={() => console.log('NoOp')}
          error={editedPriceError}
        />
      ) : null}
      <div className="">
        <ProductOptionsHOC
          product={product}
          addToCartHocArgs={hocArgs}
          renderFormField={({ form, formInputName, charges, productOption, multiple, typeOfInput }) => {
            const { values, errors, touched, submissions, handleChange, handleBlur, asyncErrors } = form;
            if (values[formInputName]) seterror(false);
            else if (!values[formInputName]) seterror(true);
            return (
              <FormInput
                name={formInputName}
                className="my-20"
                label={`${productOption.name} ${charges}`}
                type={typeOfInput}
                multiple={multiple}
                value={values[formInputName] || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                error={(submissions || touched[formInputName]) && (errors[formInputName] || asyncErrors[formInputName])}
              />
            );
          }}
          renderFormCheckboxRadioField={({ form, formInputName, optionType, optionValues, charges, productOption }) => {
            const { values, errors, touched, submissions, handleChange, handleBlur, asyncErrors } = form;
            if (values[formInputName]) seterror(false);
            else if (!values[formInputName]) seterror(true);
            return (
              <fieldset className="bg-esteem-review p-20 mb-12 first:mt-44 last:mb-0">
                <div className="flex justify-between items-center">
                  <div
                    className=" text-gray md:text-textScolor font-semibold md:font-bold leading-24 md:leading-32 text-20 md:text-21 w-full flex flex-wrap"
                    font-customisation="section-heading"
                    color-customisation="page-heading"
                  >
                    {productOption.name}
                  </div>
                  <div
                    className="text-gray md:text-textScolor font-normal leading-25 text-18 flex w-full justify-end"
                    font-customisation="section-heading"
                    color-customisation="page-heading"
                  >
                    {charges}
                  </div>
                </div>
                <FormCheckboxRadioGroup
                  className="text-input-search md:text-textScolor font-normal leading-20 text-16 md:text-14 mt-10"
                  name={formInputName}
                  type={optionType as 'radio' | 'checkbox'}
                  value={values[formInputName] || ''}
                  onChange={handleChange}
                  spaceY={'space-y-10'}
                  spaceX={'space-x-0'}
                  onBlur={handleBlur}
                  options={optionValues.map((optionValue) => ({ id: optionValue.id, value: optionValue.text }))}
                  error={
                    (submissions || touched[formInputName]) && (errors[formInputName] || asyncErrors[formInputName])
                  }
                />
              </fieldset>
            );
          }}
        />
        <CustomFieldHOC
          product={product}
          addToCartHocArgs={hocArgs}
          renderFormField={({ customFieldForm, formInputName, charges, productOption, multiple, typeOfInput }) => {
            const { values, errors, touched, submissions, handleChange, handleBlur, asyncErrors } = customFieldForm;
            if (values[formInputName]) seterror(false);
            else if (!values[formInputName]) seterror(true);
            return (
              <FormInput
                name={formInputName}
                className="my-20"
                label={`${productOption?.name} ${charges}`}
                type={typeOfInput === 'multifile' ? 'file' : typeOfInput}
                multiple={multiple}
                value={values[formInputName] || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={200}
                error={(submissions || touched[formInputName]) && (errors[formInputName] || asyncErrors[formInputName])}
              />
            );
          }}
          renderFormCheckboxRadioField={({
            customFieldForm,
            formInputName,
            optionType,
            optionValues,
            charges,
            productOption,
          }) => {
            const { values, errors, touched, submissions, handleChange, handleBlur, asyncErrors } = customFieldForm;
            if (values[formInputName]) seterror(false);
            else if (!values[formInputName]) seterror(true);
            return (
              <fieldset className="bg-esteem-review p-20 mb-12 first:mt-44 last:mb-0">
                <div className="flex justify-between items-center">
                  <div
                    className=" text-gray md:text-textScolor font-semibold md:font-bold leading-24 md:leading-32 text-20 md:text-21 w-full flex flex-wrap"
                    font-customisation="section-heading"
                    color-customisation="page-heading"
                  >
                    {productOption.name}
                  </div>
                  <div
                    className="text-gray md:text-textScolor font-normal leading-25 text-18 flex w-full justify-end"
                    font-customisation="section-heading"
                    color-customisation="page-heading"
                  >
                    {charges}
                  </div>
                </div>
                <FormCheckboxRadioGroup
                  className="text-input-search md:text-textScolor font-normal leading-20 text-16 md:text-14 mt-10"
                  name={formInputName}
                  type={optionType as 'radio' | 'checkbox'}
                  value={values[formInputName] || ''}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  spaceY={'space-y-10'}
                  spaceX={'space-x-0'}
                  options={optionValues.map((optionValue) => ({ id: optionValue.id, value: optionValue.text }))}
                  error={
                    (submissions || touched[formInputName]) && (errors[formInputName] || asyncErrors[formInputName])
                  }
                />
              </fieldset>
            );
          }}
        />
      </div>
      {showError && (
        <div className={classnames('text-ticket_variant text-14 font-medium ml-10 mt-20')}>
          Please select the required fields !
        </div>
      )}

      {finalProduct.inStock ? (
        <>
          <div className="flex flex-col md:flex-row items-center mt-20 md:mt-40" ref={ctaRef}>
            {showAddToCartButtonAlt ? (
              <div className="flex flex-col md:flex-row mt-30 md:mt-auto w-full md:w-fit justify-center sm:justify-start items-center">
                <button
                  className={classnames(
                    'ripple w-full md:w-175 min-w-full md:min-w-175 h-44 md:h-40 rounded-5 text-16 py-14 px-24 leading-19 md:leading-16   border  focus:outline-none font-bold pointer-events-auto flex justify-center items-center disabled:cursor-not-allowed disabled:opacity-50',
                    {
                      'text-white bg-esteem-heading1 border-esteem-heading1': quickView,
                      'text-disabled md:text-white bg-white md:bg-esteem-heading1 border-esteem-btnBorder md:border-esteem-heading1': !quickView,
                    },
                  )}
                  ref={cartCtaRef}
                  disabled={isAddToCartButtonDisabled}
                  onClick={() => {
                    if (quantity !== -1 && validate(selectedOptions)) {
                      addToCart({ isBuyNowFlow: false });
                    } else {
                      setshowError(true);
                      setTimeout(() => {
                        setshowError(false);
                      }, 2000);
                    }
                  }}
                  font-customisation="para-text"
                  button-customisation="addToCart-button"
                  id="add-to-cart-btn"
                >
                  Add to Cart
                </button>
                {BuyNowButton(
                  product,
                  quickView,
                  addToCart,
                  discountCode,
                  BuyNowValidate,
                  isBuyNowButtonDisabled,
                  storeType,
                )}
              </div>
            ) : (
              BuyNowButton(
                product,
                quickView,
                addToCart,
                discountCode,
                BuyNowValidate,
                isBuyNowButtonDisabled,
                storeType,
              )
            )}
            <WishlistIcon
              className="h-44 md:h-40 w-full md:w-44 focus:outline-none text-disabled md:text-esteem-heading  md:border md:border-disabled bg-white text-16 font-bold rounded-22 pointer-events-auto flex justify-center items-center disabled:opacity-20 md:ml-10"
              type={isProductInWishList ? 'addWishList' : 'removeWishList'}
              wishListFeature={wishListFeature}
              onClick={() => {
                onWishListClickHandler();
              }}
              font-customisation="para-text"
            />
          </div>
        </>
      ) : (
        <button
          className="flex justify-start mt-50 text-errorToast text-20 md:text-24 leading-30 md:leading-24 font-semibold"
          font-customisation="para-text"
        >
          Out of stock
        </button>
      )}
      {showFixedBuyNow ? (
        <div className="md:hidden fixed bottom-0 left-0 right-0 py-24 px-16 bg-opacity-90 z-99999 bg-white text-16 shadow-cartCta">
          <button
            onClick={() => ctaRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'center' })}
            className={classnames(
              'w-full md:w-175 min-w-full md:min-w-175 h-44 md:h-40 rounded-5 text-16 leading-19 py-14 px-24 md:leading-16 text-white bg-esteem-colorVariant focus:outline-none font-bold',
              ' focus:outline-none rounded-5',
              'disabled:cursor-not-allowed disabled:opacity-50 flex justify-center items-center',
            )}
            disabled={isBuyNowButtonDisabled}
            font-customisation="para-text"
            button-customisation="buyNow-button"
          >
            Buy Now
          </button>
        </div>
      ) : null}
    </div>
  );
};
export default ProductAddToCart;

const BuyNowButton = (
  product,
  quickView,
  addToCart,
  discountCode,
  BuyNowValidate,
  isBuyNowButtonDisabled,
  storeType,
) => {
  return (
    <div className="flex w-full md:ml-10 mt-20 md:mt-0">
      {quickView ? (
        <button
          className={classnames(
            'ripple flex w-full md:w-175 h-44 md:h-40 rounded-5 text-16 py-14 px-24  leading-19 md:leading-16 text-esteem-secondaryBtn border-cart-button_Variant md:border md:border-btnBorder1 bg-white focus:outline-none font-bold justify-center items-center',
          )}
          onClick={(e) => {
            document.body.style.overflow = 'scroll';
            e.preventDefault();
            history.push(product.storeLink);
          }}
          font-customisation="para-text"
          button-customisation="page-button"
        >
          View Details
        </button>
      ) : (
        <button
          className={classnames(
            'w-full md:w-175 min-w-full md:min-w-175 h-44 md:h-40 rounded-5 text-16 leading-19 py-14 px-24 md:leading-16 text-white bg-esteem-colorVariant focus:outline-none font-bold',
            ' focus:outline-none rounded-5',
            'disabled:cursor-not-allowed disabled:opacity-50 flex justify-center items-center',
          )}
          disabled={isBuyNowButtonDisabled}
          onClick={() => BuyNowValidate()}
          button-customisation="buyNow-button"
          font-customisation="para-text"
          id="buy-now-btn"
        >
          {storeType === STORE_TYPE.ENQUIRY ? 'Enquire Now' : !product.isExpired ? 'Buy Now' : 'Expired'}
        </button>
      )}
    </div>
  );
};

//QuantityOptionsBar
const QuantityOptionsBar = (quantity, setQuantity, product, cartProductQuantity, quickView) => {
  return (
    <div className="flex items-center">
      {/* <div className={classnames('grid grid-cols-auto md:grid-cols-2 md:w-220 gap-36 md:gap-20 mx-34 md:mx-0', {})}> */}
      <div className={classnames('grid grid-cols-2 md:w-220 gap-20', {})} font-customisation="para-text">
        <div
          className={classnames(
            'text-textGray md:text-textScolor font-normal text-16 leading-24 flex items-center',
            {},
          )}
          color-customisation="page-body-text"
        >
          Quantity
        </div>
        <div className="flex flex-row items-center w-165 justify-self-end md:justify-self-auto">
          <div
            className={classnames(
              'inline-flex justify-between items-center rounded-5 text-textScolor text-16 leading-22 font-normal',
              {
                'w-165 min-w-165 md:h-36 h-44': !quickView,
                'md:w-110 w-164 h-36': quickView,
              },
            )}
          >
            <button
              className="hover:focus:outline-none ripple focus:shadow-none flex justify-center items-center w-36 h-36 rounded-5 bg-esteem-review border border-esteem-btnBorder1"
              onClick={() => setQuantity(Math.max(quantity - 1, 1))}
              disabled={cartProductQuantity ? quantity === 1 : product.minQuantity === quantity}
              id="quantity-decrement"
            >
              <img src={minus} alt="-" className="" />
            </button>
            <div className="flex focus:outline-none justify-center items-center" color-customisation="page-body-text">
              {quantity}
            </div>
            <button
              className="focus:outline-none ripple focus:shadow-none flex justify-center items-center w-36 h-36 rounded-5 bg-esteem-review border border-esteem-btnBorder1"
              onClick={() => setQuantity(quantity + 1)}
              disabled={
                product.stock >= product.maxQuantity ? product.maxQuantity === quantity : product.stock === quantity
              }
              id="quantity-increment"
            >
              <img src={plus} alt="+" className="" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const CostBar = (finalPrice, savings, taxIncludedInventory) => {
  return (
    <div className="flex items-center mt-24 md:mt-25 md:justify-between justify-center">
      <div className="flex items-baseline flex-col md:flex-row ">
        <div className="flex ">
          <div
            className="flex text-esteem-price leading-25 text-21 mr-6 font-roboto-medium"
            font-customisation="para-text"
            color-customisation="page-body-text"
            id="final-price"
          >
            <Rupee value={finalPrice} />
          </div>
          <div className="flex">
            {savings ? (
              <div
                className="flex line-through font-roboto-normal leading-20 text-16 text-essense-mrprice pt-4"
                font-customisation="para-text"
                id="original-price"
              >
                <Rupee value={savings.price} />
              </div>
            ) : (
              <div className="font-normal text-12">&nbsp;</div>
            )}
          </div>
        </div>
        <div
          className="text-essense-mrprice text-12 leading-18 font-semibold md:ml-6 mb-2 flex self-end w-full justify-center md:justify-start"
          font-customisation="para-text"
        >
          {taxIncludedInventory ? 'Incl. of taxes' : 'Excl. of taxes'}
        </div>
      </div>
    </div>
  );
};
